<template>
  <div class="container">
    <div class="wrap">
      <div class="box-con">
         <div class="title">{{title}}</div>
         <div class="content" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      title:'',
      content:``,
    };
  },
  computed: {
    
  },
  mounted() {
      this.$axios.api.request({
          url: "/api/qtclub/index/getTreaty",
          data: {id: 10}
      }, (res) => {
          this.title = res.data.title;
          this.content = res.data.content;
      })
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.box-con{
  padding:40px;
  box-sizing:border-box;
  .title{
    text-align:center;
    font-size:28px;
    margin-bottom:20px;
  }
  .content{
    ::v-deep p{
      margin:10px 0;
    }
    ::v-deep img{
      max-width:100%;
    }
  }
}
</style>
